import type { StopsQueue } from '../stops-queue/stops-queue.interface';
import { STOPS_QUEUE_STATUS } from '../stops-queue/stops-queue.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class StopsQueueFactory extends ObjectFactory<StopsQueue> {
  protected getDefaults(): StopsQueue {
    return {
      ...baseDocumentFactory.build(),
      carrierId: 'ccddee112233445566778899',
      driverId: 'aabb1122334455667788aabb',
      status: STOPS_QUEUE_STATUS.ONGOING,
      stops: [],
    };
  }
}

export const stopsQueueFactory = new StopsQueueFactory();
